<template>

    <div>
        <v-btn v-if="!props.config.fab" :prepend-icon="props.config.icon? props.config.icon : 'mdi-plus'" color="deep-orange-darken-3" class="mt-2"
            @click="dialogVisible = true" :block="mobile" :size="props.config.size">
            {{ props.config.label }}

        </v-btn>
        <v-btn v-else id="btnAsIcon" color="deep-orange-darken-3" @click="dialogVisible = true"
            :icon="props.config.icon? props.config.icon : 'mdi-plus'" size="default">
        </v-btn>

        <v-bottom-sheet v-model="dialogVisible" width="auto" height="auto" theme="dark" :inset="!mobile" scrim="black">
            <v-card class="pa-2 fill-height text-center">
                <v-card-item v-if="props.config.title">
                    <v-card-title>
                        {{ props.config.title || "Aggiungi" }}
                    </v-card-title>
                </v-card-item>
                <v-card-item v-if="acceptedCapture">
                    <v-card-title>
                        Acquisisci
                    </v-card-title>
                </v-card-item>
                <v-card-text>
                    <v-card variant="flat">
                        <v-card-text class="d-flex justify-center align-center">

                        <p class="" v-if="props.config?.intro" v-html="props.config.intro"></p>
                        </v-card-text>
                        <template v-if="props.config?.capture?.image">
                            <v-card-text class="d-flex justify-center align-center">

                                <input type="file" id="capture_image" :accept="accept.image.mimetype"
                                    capture="environment" @change="fileChoosen" style="display: none" />
                                <v-btn @click="gbidclick('capture_image')" size="x-large"
                                    variant="elevated" block color="deep-orange-darken-3" class="mr-1">
                                    <template v-slot:prepend>
                                        <v-icon size="x-large">mdi-camera</v-icon>
                                    </template>
                                    Immagine
                                </v-btn>
                                <!-- <v-select v-model="accept.image" 
                            hide-details
                                :items="[
                                {title:'*',
                                value:['image/*']                                },
                                {title:'jpg', 
                                value:['image/jpg']
                                }, 
                                {title:'png',
                                value:['image/png']},]"
                                label="?" outlined dense>
                            </v-select>
                            <span>{{ accept.image }}</span> -->
                            </v-card-text>
                        </template>

                        <template v-if="props.config?.capture?.video">
                            <v-card-text class="d-flex justify-center align-center">

                                <input type="file" id="capture_video" :accept="accept.video.mimetype"
                                    capture="environment" @change="fileChoosen" style="display: none" />

                                <v-btn @click="gbidclick('capture_video')" size="x-large"
                                    variant="elevated" block color="deep-orange-darken-3" class="mr-1">
                                    <template v-slot:prepend>
                                        <v-icon size="x-large">mdi-video</v-icon>
                                    </template>
                                    Video
                                </v-btn>
                                <!-- <v-select v-model="accept.video" 
                            hide-details
                                :items="[
                                {title:'*',
                                value:['video/*']                                },
                                {title:'m4a', 
                                value:['video/m4a']
                                }, 
                                {title:'mp4',
                                value:['video/mp4']},]"
                                label="?" outlined dense></v-select>
                                <span>{{accept.video}}</span> -->

                            </v-card-text>
                        </template>

                        <template v-if="props.config?.capture?.audio">
                            <v-card-text class="d-flex justify-center align-center">

                                <input type="file" id="capture_audio" :accept="accept.audio.mimetype"
                                    capture="environment" @change="fileChoosen" style="display: none" />

                                <v-btn @click="gbidclick('capture_audio')" size="x-large"
                                    variant="elevated" block color="deep-orange-darken-3" class="mr-1">
                                    <template v-slot:prepend>
                                        <v-icon size="x-large">mdi-microphone</v-icon>
                                    </template>
                                    Audio
                                </v-btn>
                                <!-- <v-select v-model="accept.audio" 
                            hide-details
                                :items="[
                                {title:'*',
                                value:['audio/*']},
                                {title:'m4a',
                                value:['audio/*m4a']},
                                {title:'mp3', 
                                value:['audio/mp3']
                                }, 
                                {title:'ogg',
                                value:['audio/ogg']},]"
                                label="?" outlined dense></v-select>
                                <span>{{accept.audio}}</span> -->

                            </v-card-text>
                        </template>
                    </v-card>

                    <v-card variant="flat" v-if="acceptedMimeTypes">
                        <v-card-title>Files locali</v-card-title>
                        <v-card-text class="d-flex flex-column justify-center align-left">
                            <p>
                                Seleziona un file dal tuo dispositivo.
                                <v-btn size="x-small" icon @click="toggleAcceptedInfo" variant="flat">
                                    <v-icon>mdi-information</v-icon>
                                </v-btn>
                            </p>

                            <v-slide-y-transition>
                                <p v-show="showAcceptedInfo">
                                    I formati accettati sono:<br>
                                    <span class="pl-5" v-for="fileType of acceptedMimeTypes.split(',')" :key="fileType">
                                        {{ fileType }}<br>
                                    </span>
                                </p>
                            </v-slide-y-transition>

                            <input type="file" id="upload_file" :accept="acceptedMimeTypes" @change="fileChoosen"
                                style="display: none" />
                            <v-btn @click="gbidclick('upload_file')" size="x-large" variant="elevated"
                                block color="deep-orange-darken-3" class="my-4">
                                <template v-slot:prepend>
                                    <v-icon size="x-large">mdi-upload</v-icon>
                                </template>
                                Seleziona
                            </v-btn>
                        </v-card-text>
                    </v-card>

                </v-card-text>

                <!-- <v-card-text class="d-flex">
                    <pre>{{ props }}</pre>
                </v-card-text> -->
                <v-card-actions class="flex-grow-0 justify-center">

                    <v-btn variant="outlined" size="large" color="white" @click="dialogVisible = false">
                        <v-icon>mdi-chevron-down</v-icon>
                        indietro</v-btn>
                </v-card-actions>

                <v-spacer />
            </v-card>
        </v-bottom-sheet>
    </div>
</template>

<script setup>

import { ref, computed } from "vue";
import slugify from "slugify";

import { useFilesStore } from "@/store/files";
import { useRuntimeStore } from "@/store/runtime"

import { useToastsStore } from "@/store/toasts";

import { useDisplay } from 'vuetify'
const { mobile } = useDisplay()

const gbidclick = (id) => {
    // get by id and click
    document.getElementById(id).click()
}

const toastsStore = useToastsStore()

const emit = defineEmits(['onFileAdded', 'onFileReaded'])
const props = defineProps(
    {
        config: {
            type: Object, default: () => {
                return {
                    destination: "consume", // or "save"
                    fab: false,
                    label: "Aggiungi",
                    size: "x-large",
                    intro: "",
                    title: null,
                    purpose: null,
                    target_uuid: null,
                    file: {
                        audio: true,
                        video: true,
                        image: true,
                        geojson: false,
                    },
                    capture: {
                        audio: true,
                        video: true,
                        image: true,
                    },
                }
            }
        }
    })


// console.log(props.config)

const accept = ref({
    everything: {
        mimetype: "*",
        extensions: ["*", ]
    },
    audio: {
        mimetype: "audio/*",
        extensions: ["mp3", "ogg",]
    },
    video: {
        mimetype: "video/*",
        extensions: ["mp4", "avi",]
    },
    image: {
        mimetype: "image/*",
        extensions: ["png", "jpg",]
    },
    geojson: {
        mimetype: "application/geo+json",
        extensions: ["geojson", "json",]
    },    
    gpx: {
        mimetype: "application/gpx+xml",
        extensions: ["gpx",]
    },
    txt: {
        mimetype: "text/plain",
        extensions: ["txt",]
    },
    json: {
        mimetype: "application/json",
        extensions: ["json",]
    },
})

const showAcceptedInfo = ref(false)


const acceptedMimeTypes = computed(() => {


    const acceptedMimeTypesArray = []
    if (props?.config?.file?.everything) {
        acceptedMimeTypesArray.push(accept.value.everything.mimetype)
    }
    if (props?.config?.file?.audio) {
        acceptedMimeTypesArray.push(accept.value.audio.mimetype)
    }
    if (props?.config?.file?.video) {
        acceptedMimeTypesArray.push(accept.value.video.mimetype)
    }
    if (props?.config?.file?.image) {
        acceptedMimeTypesArray.push(accept.value.image.mimetype)
    }
    if (props?.config?.file?.geojson) {
        acceptedMimeTypesArray.push(accept.value.geojson.mimetype)
    }    
    if (props?.config?.file?.gpx) {
        acceptedMimeTypesArray.push(accept.value.gpx.mimetype)
    }
    if (props?.config?.file?.txt) {
        acceptedMimeTypesArray.push(accept.value.txt.mimetype)
    }
    if (props?.config?.file?.json) {
        acceptedMimeTypesArray.push(accept.value.json.mimetype)
    }

    console.log(acceptedMimeTypesArray)
    let the_string = acceptedMimeTypesArray.join(",")

    // console.log(acceptedMimeTypes)

    return the_string
})




const acceptedExtensions = computed(() => {

    // console.log(props.config)

    let acceptedExtensionsArray = []

    if (props.config?.file?.audio  ||  props.config?.capture?.audio ) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.audio.extensions]
    }
    if (props.config?.file?.everything  ||  props.config?.capture?.everything ) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.everything.extensions]
    }
    if (props.config?.file?.video  ||  props.config?.capture?.video ) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.video.extensions]
    }
    if (props.config?.file?.image  ||  props.config?.capture?.image ) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.image.extensions]
    }

    if (props.config?.file?.geojson) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.geojson.extensions]
    }
    if (props.config?.file?.gpx) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.gpx.extensions]
    }
    if (props.config?.file?.txt) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.txt.extensions]
    }
    if (props.config?.file?.json) {
        acceptedExtensionsArray = [...acceptedExtensionsArray, ...accept.value.json.extensions]
    }
    // console.log(acceptedMimeTypes)

    return acceptedExtensionsArray
})


const acceptedCapture = computed(() => {
    if (props.config.capture?.audio) return true
    if (props.config.capture?.video) return true
    if (props.config.capture?.image) return true
    return false
})


const runtimeStore = useRuntimeStore();
const filesStore = useFilesStore()


const userPk = runtimeStore?.session?.user?.pk


const dialogVisible = ref(false)


const toggleAcceptedInfo = () => {
    showAcceptedInfo.value = !showAcceptedInfo.value

}
const fileChoosen = (e) => {


    // console.log(e)

    const file = e.target.files[0];

    const reader = new FileReader();



    // Failed to execute 'readAsDataURL' on 'FileReader': parameter 1 is not of type 'Blob'.
    // ???
    // reader.readAsArrayBuffer(file);
    
    
    if ( ["restore","consume"].includes(props.config.destination)) {


        // I should check if the file is a text file or a binary file
        // and read it accordingly
        // https://stackoverflow.com/questions/14438187/how-to-determine-if-a-file-is-binary-or-text-in-python
        // https://stackoverflow.com/questions/10261986/determine-if-a-file-is-binary-or-text-in-python
        
        // I should check the mimetype of the file
        
        reader.readAsText(file);
    }
    else{
        reader.readAsDataURL(file);
    }

   reader.onload = async () => {

        const now = new Date(Date.now()).valueOf()
        const extension = slugify(
            file.name.split(".").pop(),

            {
                lower: true,
                strict: true,
                trim: true,
            })
        const simpleName = slugify(
            file.name.split(".").slice(0, -1).join("."),
            {
                lower: true,
                strict: true,
                trim: true,
            })


        const name = userPk + "-" + simpleName + "-" + now + "." + extension



        const mediaObject = {
            content: reader.result,
            name: name,
            extension: extension,
            mimetype: file.type,
            created_at: now
        }

        if (props.config.target_uuid) {
            mediaObject.target_uuid = props.config.target_uuid
        }

        if (props.config.purpose) {
            mediaObject.purpose = props.config.purpose
        }

        console.log(props.config)
        console.log(props.config?.purpose || "no purpose")

        console.log(extension)
        console.log(acceptedExtensions.value)

        if (!acceptedExtensions.value.includes("*")) {
        if (!acceptedExtensions.value.includes(extension)) {
            toastsStore.toast({
                title: `Files`,
                text: `Estensione ${extension} non supportata.`,
                type: "error",
            })
    
            return false
        }
        }



        if ( ["restore","consume"].includes(props.config.destination)) {
            emit('onFileReaded', mediaObject)
        }
        else{
            await filesStore.add(mediaObject)
        }


        emit('onFileAdded', name)

        dialogVisible.value = false

    };
}



</script>

<style scoped>
#btnAsIcon {
    pointer-events: auto;
    margin: .3em;
}
</style>
